"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getError_1 = __importDefault(require("./getError"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const clone_1 = __importDefault(require("lodash/clone"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const difference_1 = __importDefault(require("lodash/difference"));
const Errors_1 = __importDefault(require("../Errors"));
const convertTypedModel_1 = require("./convertTypedModel");
async function doValidation(params) {
    (0, convertTypedModel_1.convertTypedModel)(params);
    const { schema, doc, currentDoc, value, currentSchema, keys = [], addError, options, args } = params;
    const info = { schema, doc, currentDoc, value, currentSchema, keys, options, args, addError };
    const error = await (0, getError_1.default)(info);
    if (error) {
        addError(keys, error);
        return;
    }
    if ((0, isNil_1.default)(value))
        return;
    /**
     * Deep validation
     */
    if ((0, isPlainObject_1.default)(currentSchema.type)) {
        const type = currentSchema.type;
        if (typeof type?.__skipChildValidation === 'function') {
            if (await type?.__skipChildValidation(value, info)) {
                return;
            }
        }
        const schemaKeys = Object.keys(currentSchema.type).filter(key => !key.startsWith('__'));
        for (const key of schemaKeys) {
            const itemSchema = currentSchema.type[key];
            const itemValue = value[key];
            const keyItemKeys = (0, clone_1.default)(keys);
            keyItemKeys.push(key);
            await doValidation({
                ...info,
                currentDoc: value,
                value: itemValue,
                currentSchema: itemSchema,
                keys: keyItemKeys
            });
        }
        const documentKeys = Object.keys(value);
        const notInSchemaKeys = (0, difference_1.default)(documentKeys, schemaKeys);
        for (const key of notInSchemaKeys) {
            const keyItemKeys = (0, clone_1.default)(keys);
            keyItemKeys.push(key);
            addError(keyItemKeys, Errors_1.default.NOT_IN_SCHEMA);
        }
    }
    else if ((0, isArray_1.default)(currentSchema.type)) {
        const itemSchema = currentSchema.type[0];
        for (let i = 0; i < value.length; i++) {
            const itemValue = value[i];
            const keyItemKeys = (0, clone_1.default)(keys);
            keyItemKeys.push(i.toString());
            await doValidation({
                ...info,
                currentDoc: value,
                value: itemValue,
                currentSchema: { type: itemSchema },
                keys: keyItemKeys
            });
        }
    }
}
exports.default = doValidation;
